<div class="container-fluid">
    <div class="row">
        <div class="studentImage">
        </div>
    </div>
    <div class="row content py-5">
      <p class="heading text-center mb-4">Welcome to HSR's K-12 Fast-Track</p>
      <div class="d-flex flex-wrap justify-content-center align-items-start">

        <div class="mx-1" style="width: 500px;">
            <p class="subHeading">Student Lookup Web Tool</p>
            <div>
                <p class="text">This tool provide agents and other officials (campus, district, and state) the
                    opportunity to search their respective schools' student insurance coverage plans.</p>
            </div>
        </div>

        <div class="mx-1" style="width: 500px;">
          <div>
              <p class="subHeading">Results can be obtained through either:</p>

          </div>
          <div>
              <p class="text">Keyword Search ("Search For Student link"), or <br />
                  Campus Search ("Search For Student By Campus" link)</p>
          </div>
        </div>
      </div>

        <!-- <div class="col-lg-5 col-md-5 col-sm-12">
            <div class="card">
                <div class="card-heading">
                    <p>Want Access or Access Maintenance?<br />Contact a District-Level Official</p>
                </div>
                <div class="searchDistrict row ">
                        <div class="main col-lg-10 col-md-12 col-sm-12">
                            <select id="schoolDistrict" name="schoolDistrict" (change)="checkDistrict()"
                            [(ngModel)]="selectedPolicyNo">
                                <option value="0" selected disabled>Select School District</option>
                                <option *ngFor="let dist of districts" [value]="dist.policyNo">
                                    {{dist.state}}-{{dist.client}}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-1 col-md-12 col-sm-12"><button class="go" (click)="OpenDistrictOfficialPopup()">Go</button></div>
                        <p *ngIf="isError" class="error">Select School District from Drop Down!</p>
                </div>
            </div>
        </div> -->
    </div>
</div>
